import jwtDefaultConfig from './jwtDefaultConfig'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  // store token
  token = null

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // Get token from localStorage
        const accessToken = this.getToken()

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => response,
      error => {
          const { config, response } = error
          const originalRequest = config

          if (response.status === 401 && config.url !== this.jwtConfig.refreshEndpoint) {

              if (!this.isAlreadyFetchingAccessToken) {

                  this.isAlreadyFetchingAccessToken = true
                  this.refreshToken()
                      .then(()=> {
                          this.onAccessTokenFetched()
                          this.isAlreadyFetchingAccessToken = false
                      })
              }
              const retryOriginalRequest = new Promise(resolve => {
                  this.addSubscriber(() => resolve(this.axiosIns(originalRequest)))
              })
              return retryOriginalRequest
          }

          return Promise.reject(error)
      },
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  setToken(value) {
    this.token = value
  }

  getToken() {
    return this.token
  }

  refreshToken(...args) {
    return new Promise((resolve, reject) => {
      this.axiosIns.post(this.jwtConfig.refreshEndpoint)
        .then((response)=> {
            this.setToken(response.data.access)
            resolve(response)
        })
        .catch((err) => reject(err))
    })
  }

  login(...args) {
    return new Promise((resolve, reject) => {
      this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args)
          .then((response)=> {
              this.setToken(response.data.access_token)
              resolve(response)
          })
          .catch((err) => reject(err))
    })
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  logout(...args) {
    return new Promise((resolve, reject) => {
      this.axiosIns.post(this.jwtConfig.logoutEndpoint)
          .then((response)=> {
              this.setToken(null)
              resolve(response)
          })
          .catch((err) => reject(err))
    })
  }

  sendPasswordResetEmail(...args) {
    return this.axiosIns.post(this.jwtConfig.sendPasswordResetEmailEndpoint, ...args)
  }

  resetPassword(...args) {
      return new Promise((resolve, reject) => {
          this.axiosIns.post(this.jwtConfig.resetPasswordEndpoint, ...args)
              .then((response)=> resolve(response))
              .catch((err) => reject(err))
      })
  }

}
